var $uploadCrop = null;

function setUploadCrop() {
    $uploadCrop = $('#upload-demo-logo').croppie({
        viewport: { width: 300, height: 150 },
        boundary: { width: 380, height: 330 },
        showZoomer: true,
        url: 'images/report_company_logo.png',
        // enableResize: true,
        enforceBoundary: false,
        forceceBoundary: false,
        enableExif: true,
        enableOrientation: true,
    });
}

setUploadCrop();

$('#upload-logo').on('change', function() {
    $('#btn-upload-logo').addClass('d-none');
    $('#block-for-after-upload').removeClass('d-none');
    var reader = new FileReader();
    reader.onload = function(e) {
        $uploadCrop.croppie('bind', {
            url: e.target.result
        }).then(function() {
            console.log('jQuery bind complete');
        });
    }
    reader.readAsDataURL(this.files[0]);
});

function resetCroppie() {
    // $('.upload-demo').removeClass('ready');
    $('#upload-demo-logo').html("");
    $uploadCrop = null;

    setUploadCrop();
}


$('.upload-result-logo').on('click', function(ev) {
    if ($('#upload-logo').val() != '') {
        $uploadCrop.croppie('result', {
            type: 'canvas',
            size: 'viewport'
        }).then(function(resp) {
            $.post('/upload_crop_logo', {
                _token: $('meta[name="csrf-token"]').attr('content'),
                image: resp,
            }, function(responce) {
                console.log(responce);
                toastr.success('Изображение успешно загружено');
                $('#block-for-after-upload').addClass('d-none');
                $('#btn-upload-logo').removeClass('d-none');
                $('#exit-preview-logo').addClass('d-none');
                $('#delete-logo-report').removeClass('d-none');
                // exitPreviewLogo();
            });
        });
    } else {
        toastr.warning('Выберите изображение');
    }
});

$('#reports-preview-logo').on('click', function() {

    $.post('/get_fish_reports', {
        _token: $('meta[name="csrf-token"]').attr('content'),
    }, function(responce) {

        let oListFishReports = responce;

        let sHtmlUl = '';

        let oListReportHtml = $('<ul>', {
            class: 'nav',
            css: {
                textAlign: 'left',
            },
        });

        let oPointListReport = $('<li>', {
            class: 'nav-item',
            css: {
                width: '100%',
            },
        });

        let oLinkPointListReport = $('<a>', {
            class: 'nav-link ident-show-fish-report',
            css: {
                color: '#ff6611',
                cursor: 'pointer',
            },
        });

        let oPointContainer = null;
        let oLinkContainer = null;

        let inc = 1;

        for (let identFile in oListFishReports) {

            oLinkContainer = oLinkPointListReport.clone();
            oLinkContainer.attr("data-ident", identFile);
            oLinkContainer.text(inc + ".  " + oListFishReports[identFile]);

            oPointContainer = oPointListReport.clone();
            oPointContainer.append(oLinkContainer);
            oListReportHtml.append(oPointContainer);

            inc++;
        }

        sHtmlUl = $('<div>').append(oListReportHtml).html();

        Swal.fire({
            title: 'Выберите отчёт для демонстрации.',
            html: sHtmlUl,
            showConfirmButton: false,
            showCloseButton: true,
            showCancelButton: false,
        });
    });
});

$('#load-other-img').on('click', function() {
    // $('#block-for-after-upload').addClass('d-none');
    // $('#btn-upload-logo').removeClass('d-none');
    // exitPreviewLogo();
    location.reload();
});

$('#delete-logo-report').on('click', function() {

    Swal.fire({
        title: 'Вы уверены, что хотите удалить лого?',
        status: 'warning',
        cancelButtonText: 'Нет',
        confirmButtonText: 'Да'
    }).then((result) => {
        $.post('/delete_report_logo', {
            _token: $('meta[name="csrf-token"]').attr('content'),
        }, function(responce) {
            if (responce == "success") {
                Swal.fire({
                    title: 'Лого успешно удалено!',
                    status: 'success',
                    confirmButtonText: 'Ок'
                }).then((result) => {
                    if (result.value) {
                        window.location.reload();
                    }
                });
            } else {
                Swal.fire(
                    'Произошла ошибка!',
                    'error'
                );
                //
            }
        });
    });

});

$('#exit-preview-logo').on('click', function() {
    exitPreviewLogo();
});

$(document).on('click', '.ident-show-fish-report', function() {

    $('#exit-preview-logo').removeClass('d-none');
    // $('#reports-preview-logo').addClass('d-none');

    let sIdentFileForDemo = $(this).data('ident');
    Swal.close();
    $.post('/get_report_html_for_demo', {
        _token: $('meta[name="csrf-token"]').attr('content'),
        identFile: sIdentFileForDemo,
    }, function(responce) {
        $("#block-demo-report").addClass("col-6");
        $("#block-upload-logo").removeClass("col-12");
        $("#block-upload-logo").addClass("col-6");
        $("#block-demo-report").html(responce);

        $.post('/get_legal_info_company_for_report', { _token: $('meta[name="csrf-token"]').attr('content') }, function(responce) {
            $('#legal_info_company').html(responce);
        });

        setDemoImg();

    });
});

$uploadCrop.on('update.croppie', function(ev, cropData) {
    setDemoImg();
});

function setDemoImg() {
    $uploadCrop.croppie('result', {
        type: 'base64',
        size: 'viewport'
    }).then(function(resp) {
        $('#report_company_logo').attr('src', resp);
    });
}

function exitPreviewLogo() {
    $('#reports-preview-logo').removeClass('d-none');
    $('#exit-preview-logo').addClass('d-none');
    $(this).addClass('d-none');
    $("#block-demo-report").removeClass("col-6");
    $("#block-upload-logo").addClass("col-12");
    $("#block-upload-logo").removeClass("col-6");
    $("#block-demo-report").html('');
}